import { useRef, useState } from 'react';
import type { FC } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Avatar, Box, Button, ButtonBase, Checkbox, Divider, FormControlLabel, ListItemIcon, ListItemText, MenuItem, Popover, Typography } from '@mui/material';
import useAuth from '../../../hooks/useAuth';
import CogIcon from '../../../icons/Cog';
import UserIcon from '../../../icons/User';
import useGlobals from 'src/hooks/useGlobals';
import { Logger } from 'src/utils/logger';
import useSnackbar from 'src/hooks/useSnackbar';

const AccountPopover: FC<React.PropsWithChildren<unknown>> = () => {
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const { openSnackBar } = useSnackbar();
  const { globals, setCustomerPresent } = useGlobals();
  const CustomerPresent: boolean = globals.customerPresent;

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleLogout = async (): Promise<void> => {
    try {
      handleClose();
      await logout();
      navigate('/');
    } catch (err) {
      Logger.error(err);
      openSnackBar('Unable to logout.', 'error', 3000);
    }
  };

  if (!user) {
    return <> </>;
  }

  return (
    <div className="global-header__account-pop-over">
      <Box
        component={ButtonBase}
        onClick={handleOpen}
        ref={anchorRef}
        sx={{
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <Avatar
          src={user?.avatar ?? '/static/avatars/anon.png'}
          sx={{
            height: 32,
            width: 32,
          }}
        />
        {CustomerPresent && <Avatar className="present-customer" sx={{ fontSize: '5px' }} children={<UserIcon />} />}
      </Box>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        keepMounted
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: { width: 240 },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography color="textPrimary" variant="subtitle2">
            {user.name}
          </Typography>
          {/* <Typography color="textSecondary" variant="subtitle2">
            Subtitle could go here
          </Typography> */}
        </Box>
        <Divider />
        <Box sx={{ mt: 2 }}>
          {/* <MenuItem component={RouterLink} to="/dashboard/social/profile">
            <ListItemIcon>
              <UserIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography color="textPrimary" variant="subtitle2">
                  Profile
                </Typography>
              }
            />
          </MenuItem> */}
          <MenuItem component={RouterLink} to="/account/settings">
            <ListItemIcon sx={{ mr: 0, width: '28px !important', minWidth: '0 !important' }}>
              <CogIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography color="textPrimary" variant="subtitle2">
                  Settings
                </Typography>
              }
            />
          </MenuItem>
          <MenuItem>
            <FormControlLabel
              control={<Checkbox color="secondary" disableRipple size="small" checked={globals.customerPresent} onChange={(e) => setCustomerPresent(e.target.checked)} />}
              label={
                <Typography color="textPrimary" variant="subtitle2">
                  With Customer
                </Typography>
              }
              className=""
            />
          </MenuItem>
        </Box>
        <Box sx={{ p: 2 }}>
          <Button color="primary" fullWidth onClick={handleLogout} variant="outlined">
            Logout
          </Button>
        </Box>
      </Popover>
    </div>
  );
};

export default AccountPopover;
